module.exports = "<app-contact-form></app-contact-form>\r\n<app-contact-buttons></app-contact-buttons>\r\n<app-button-up></app-button-up>"